import Swiper from 'swiper'
import { Navigation, Autoplay } from 'swiper/modules'

export default class SliderChambres {
  constructor(el) {
    this.el = el
    this.swiper = null
    this.init()
  }

  init() {
    this.progressFill = this.el.querySelector('.slider-chambres--progress-fill')
    const slideCount = this.el.querySelectorAll('.swiper-slide').length

    this.swiper = new Swiper(this.el.querySelector('.slider-chambres--swiper'), {
      modules: [Navigation, Autoplay],
      slidesPerView: 1,
      spaceBetween: 0,
      allowTouchMove: false,
      loop: true,
      breakpoints: {
        992: {
          slidesPerView: 'auto',
          spaceBetween: 16,
        },
      },
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      navigation: {
        nextEl: this.el.querySelector('.swiper-button-next'),
      },
    })

    let lastIndex = 0

    const updateProgress = () => {
      const index = this.swiper.realIndex
      const isReset = index === 0 && lastIndex === slideCount - 1
      this.progressFill.style.transition = isReset ? 'none' : 'width 0.4s ease'
      this.progressFill.style.width = `${((index + 1) / slideCount) * 100}%`
      lastIndex = index
    }

    this.swiper.on('slideChange', updateProgress)
    updateProgress()

    this.btn = this.el.querySelector('.slider-chambres--btn')
    this.swiperEl = this.el.querySelector('.slider-chambres--swiper')

    // Différé en rAF : on lit les positions une fois le layout Swiper à jour
    const reposition = () => requestAnimationFrame(() => this.positionArrow())
    reposition()
    window.addEventListener('resize', reposition)
    window.addEventListener('load', reposition)
    this.swiper.on('resize', reposition)
    this.swiper.on('update', reposition)
    this.swiper.on('slideChangeTransitionEnd', reposition)
  }

  // Centre la flèche dans le gap entre la dernière slide entièrement visible
  // et la suivante, à partir des positions réelles — valable à toute largeur d'écran
  positionArrow() {
    if (!this.btn || !this.swiperEl) return

    // En dessous de 992px : une slide pleine largeur, on garde le positionnement CSS
    if (window.innerWidth < 992) {
      this.btn.style.left = ''
      this.btn.style.right = ''
      return
    }

    const vw = window.innerWidth
    const sectionLeft = this.el.getBoundingClientRect().left
    const slides = this.swiperEl.querySelectorAll('.swiper-slide')

    // Bord droit de la slide la plus à droite encore entièrement visible
    let aRight = null
    slides.forEach(slide => {
      const r = slide.getBoundingClientRect()
      if (r.right <= vw + 1 && (aRight === null || r.right > aRight)) aRight = r.right
    })
    if (aRight === null) return

    // Bord gauche de la slide immédiatement suivante
    let bLeft = null
    slides.forEach(slide => {
      const r = slide.getBoundingClientRect()
      if (r.left >= aRight - 1 && (bLeft === null || r.left < bLeft)) bLeft = r.left
    })

    // Centrée dans le gap entre la dernière slide visible et la suivante (entre les images)
    // Décalage de 40px vers la gauche, en max(rem, vw) comme le reste du projet
    const remPx = parseFloat(getComputedStyle(document.documentElement).fontSize)
    const nudge = Math.max(5.625 * remPx, 0.0625 * vw) // max(5.625rem, 6.25vw) = 90px @1440
    const center = (bLeft === null ? aRight : (aRight + bLeft) / 2) - nudge

    this.btn.style.right = 'auto'
    this.btn.style.left = `${center - sectionLeft - this.btn.offsetWidth / 2}px`
  }
}
